<template>
  <!-- 服务 -->
  <div id="enterprise-serve" v-if="enterpriseInfo">
    <div class="enterprise-serve-type">
      <div class="enterprise-serve-item">
        <div class="enterprise-serve-item-value">
          <el-table
            :data="tableData"
            style="width: 100%"
            border
            :header-cell-style="{
              background: '#F5F7FA',
              color: '#111A34',
              fontWeight: 700,
            }"
          >
            <el-table-column type="index" width="40"></el-table-column>
            <el-table-column
              label="日程事项"
              prop="title"
              show-overflow-tooltip
              min-width="150"
            />
            <el-table-column
              label="时间"
              prop=""
              show-overflow-tooltip
              min-width="130"
            >
              <template slot-scope="scope">
                {{ scope.row.startTime }} - {{ scope.row.endTime }}
              </template>
            </el-table-column>
            <el-table-column
              label="创建人"
              prop="createUserName"
              show-overflow-tooltip
              min-width="100"
            />
            <el-table-column
              label="参与人"
              prop="participants"
              show-overflow-tooltip
              min-width="150"
            >
              <template slot-scope="scope">
                {{ scope.row.participants.join("、") }}
              </template>
            </el-table-column>
            <el-table-column
              label="状态"
              prop="statusName"
              show-overflow-tooltip
              min-width="100"
            >
              <template slot-scope="scope">
                <span :style="{ color: scope.row.color }">{{
                  scope.row.statusName
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="完成时间"
              prop="finishedTime"
              show-overflow-tooltip
              min-width="100"
            />
            <el-table-column
              label="出访记录"
              prop="visitReason"
              show-overflow-tooltip
              min-width="100"
            />
            <el-table-column
              label=""
              prop=""
              show-overflow-tooltip
              min-width="80"
            >
              <template slot="header">
                操作
                <i
                  style="cursor: pointer; color: #409eff; font-size: 16px"
                  class="el-icon-circle-plus-outline"
                  v-showFunction="{
                    active: 'addArchives',
                    array: allFunctionButtons,
                  }"
                  @click="handleClick('', 0)"
                ></i>
              </template>
              <template slot-scope="scope">
                <el-button
                  type="danger"
                  plain
                  size="mini"
                  @click="handleClick(scope.row, 1)"
                  >删除</el-button
                >
                <!-- v-showFunction="{
                    active: 'deleteServe',
                    array: allFunctionButtons,
                  }" -->
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 弹出框 -->
    <div id="my-dialog" v-if="dialogData.flag">
      <my_dialog7
        :width="dialogData.width"
        :title="dialogData.title"
        :buttonArray="dialogData.buttonArray"
        :data="dialogData.data"
        :allFunctionButtons="allFunctionButtons"
        @colseDialog="colseDialog"
        @dialogOper="drawerOper"
      ></my_dialog7>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    clientInfo: {
      type: Object,
      default: () => {},
    },
    tabActive: {
      type: Object,
      default: () => {},
    },
    enterpriseInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      baseInfo: {},
      tableData: [],
      tempData: {},
      allUserList: [],
      allRoleList: [],
      clientDrawerOptions: this.$tagData.getDrawerOptionsList("clientInfo"),
      pageData: {
        // 分页参数
        currentPage: 1, // 当前页数
        total: 0, // 总条目数
        pageSize: 10, // 每页条数
      },
      dialogData: {
        flag: false,
        width: "30%",
        title: "新增档案",
        buttonArray: [
          {
            text: "确认",
            active: "confirm",
          },
        ],
        data: [],
      },
      allFunctionButtons: this.$featureData.getAllFunctionButtons("clientInfo"),
    };
  },
  methods: {
    getModelFeatureAuthority() {
      console.log("获取权限");
      this.$authority.getModelFeatureAuthority(
        this,
        "clientInfo",
        this.allFunctionButtons,
        (data) => {
          this.allFunctionButtons = data;
          this.getEmployeeListForDownBox();
          console.log("当前显示的按钮权限", data);
        },
      );
    },
    /**
     * 获取所有人员列表
     */
    getEmployeeListForDownBox() {
      let requestData = {
        companyId: this.baseInfo.company.companyId,
      };
      this.$request(
        "post",
        "/user/getEmployeeListForDownBox",
        requestData,
        (data) => {
          this.allUserList = data;
          this.$tagData.getTagList(
            this.clientDrawerOptions,
            ["日程事项"],
            this.baseInfo.company.companyId,
            this,
          );
          this.getBusinessAuthorityList();
        },
      );
    },
    /**
     * 获取所有业务角色
     */
    getBusinessAuthorityList() {
      let requestData = {
        companyId: this.baseInfo.company.companyId,
      };
      this.$request(
        "post",
        "/role/getBusinessAuthorityList",
        requestData,
        (data) => {
          this.allRoleList = [];
          data.forEach((element) => {
            let dd = {
              label: element.authorityName,
              value: element.authorityId,
            };
            this.allRoleList.push(dd);
          });
          this.initTableData();
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    initTableData() {
      this.loading = true;
      let requestData = {
        clientId: this.clientInfo.id,
        currentPage: this.pageData.currentPage,
        pageSize: this.pageData.pageSize,
      };
      this.$request(
        "post",
        "/schedule/getByClient",
        requestData,
        (data) => {
          this.tableData = data.records;
          this.tableData.forEach((item) => {
            switch (item.status) {
              case "1":
                item.statusName = "未开始";
                item.color = "#409eff";
                break;
              case "2":
                item.statusName = "进行中";
                item.color = "#67c23a";
                break;
              case "3":
                item.statusName = "已结束";
                item.color = "#e6a23c";
                break;
              case "4":
                item.statusName = "已逾期";
                item.color = "#f56c6c";
                break;
              default:
                break;
            }
          });
          this.loading = false;
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    handleClick(data, flag, batch) {
      this.tempData = data;
      switch (flag) {
        case 0:
          this.dialogData.width = "600px";
          this.dialogData.title = "新增日程";
          this.dialogData.buttonArray = [
            {
              text: "确认",
              active: "sure_add",
            },
            {
              text: "取消",
              active: "cancel",
            },
          ];
          let options = {
            visibleUsersList: this.searchData.allUserList, // 下拉选项 可选人员列表
            businessRoleList: this.searchData.allRoleList, // 下拉选项 可选业务角色列表
            workList: this.clientDrawerOptions.workList, // 下拉选项 可选工作列表
            departmentList: [], // 下拉选项 可选部门List,
          };
          this.dialogData.data = taskData.addScheduleDialog(options, true);
          this.dialogData.flag = true;
          break;
        case 1:
          this.$confirm("此操作将永久删除该日程, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.$request(
                "get",
                "/schedule/delete?id=" + data.id,

                {},
                (data) => {
                  this.$message.success("删除成功!");
                  this.initTableData();
                  this.$operationRecords.saveOperationRecords(
                    this.clientInfo.id,
                    "删除日程-" + data.title,
                    this.baseInfo,
                    "client",
                    this,
                    (data2) => {},
                  );
                },
              );
            })
            .catch(() => {});
          break;
        default:
          break;
      }
    },
    drawerOper(active) {
      let requestData = {};
      switch (active) {
        case "sure_add":
          requestData = {
            createUserId: this.baseInfo.userId, // 创建人 id
            title: this.dialogData.data[0].value, // 日程名称
            bindClientId: this.clientInfo.id, // 客户id
            playersType: this.dialogData.data[1].data.playersType, // 参与者类型（'1'-人员；'2'-角色）
            visibleUsers: this.dialogData.data[1].data.visibleUsers, // 具体可见用户集合（JSON字符串），如果参与者类型是 '1' 则该字段必填
            businessRole: this.dialogData.data[1].data.businessRole, // 选择的业务角色
            clientCondition: this.dialogData.data[1].data.clientCondition, // 客户范围的筛选条件信息（JSON字符串）
            // department: this.dialogData.data[1].data.department, // 选择的部门
            time: this.dialogData.data[2].value, // 日程时间
            repeatRule: this.dialogData.data[3].value, // 重复规则（不重复、每月）
            completeMethod: this.dialogData.data[4].value, // 完成方式：'1' - 逐步完成 '2' - 同步完成
            remind: this.dialogData.data[5].value, // 推送提醒
            content: this.dialogData.data[6].value, // 任务内容
            clientIds: [this.clientInfo.id], // 客户 id 集合 只在客户抽屉里有
          };
          if (!requestData.title) {
            return this.$message.error("日程事项不可为空!");
          }
          if (requestData.time.length == 0) {
            return this.$message.error("日程时间不可为空!");
          }
          if (requestData.playersType == "1") {
            if (requestData.visibleUsers.length == 0) {
              return this.$message.error("可见用户不可为空!");
            }
          } else if (requestData.playersType == "2") {
            if (requestData.businessRole.length == 0) {
              return this.$message.error("业务角色不可为空!");
            }
          } else if (requestData.playersType == "3") {
            if (requestData.department.length == 0) {
              return this.$message.error("部门不可为空!");
            }
          }
          requestData.businessRole = JSON.stringify(requestData.businessRole);
          requestData.visibleUsers = JSON.stringify(requestData.visibleUsers);
          requestData.clientIds = JSON.stringify(requestData.clientIds);
          requestData.clientCondition = JSON.stringify(
            requestData.clientCondition,
          );
          this.$request(
            "post",
            "/schedule/add",
            requestData,
            (data) => {
              this.$message.success("添加成功!");
              this.dialogData.flag = false;
              this.initTableData();
              this.$operationRecords.saveOperationRecords(
                this.clientInfo.id,
                "新增日程日程-" + requestData.title,
                this.baseInfo,
                "client",
                this,
                (data2) => {},
              );
            },
            (errorMessage) => {
              this.$message.error(errorMessage);
            },
          );
          break;
        case "cancel":
          this.colseDialog();
          break;
        default:
          break;
      }
    },
    colseDialog() {
      this.dialogData.flag = false;
    },
  },
  mounted() {
    this.baseInfo = JSON.parse(sessionStorage.getItem("userData"));
    this.getModelFeatureAuthority();
  },
};
</script>

<style lang="less" scoped>
#enterprise-serve {
  width: 100%;
  background-color: #fff;
  .enterprise-serve-type {
    width: 100%;
    .enterprise-serve-item {
      width: 100%;
      margin-top: 32px;
      scroll-margin-top: 180px;
      &:first-child {
        margin-top: 0;
      }

      .enterprise-serve-item-title {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 8px;
        font-weight: 500;
        font-size: 16px;
        line-height: 28px;
        .enterprise-serve-item-title-search {
          display: flex;
          .search-item {
            margin-left: 5px;
          }
        }
      }
      .enterprise-serve-item-tag {
        display: flex;
        margin: 12px 0;
        .tag {
          font-size: 14px;
          color: #777e95;
          cursor: pointer;
          height: 28px;
          padding: 0 12px;
          line-height: 28px;
          cursor: pointer;
          border-radius: 14px;
        }
        .is-active {
          color: #327bf9;
          background: #eaf2ff;
        }
        .is-disabled {
          color: #c3c8da;
          cursor: not-allowed;
        }
      }
      .enterprise-serve-item-value {
        width: 100%;
      }
    }
  }
}
</style>
